import { Link } from "react-router-dom";
import { UserProfileInline } from "app/components/UserProfileInline";
import Api from "utils/api/Api";
import { useQuery } from "@tanstack/react-query";

export const HomeDebateTopic = () => {
  const {data:debateTopicLatest, isLoading, isError} = useQuery({
    queryKey:['/home/debate/topic'],
    queryFn:()=>Api.get('/api/debate/topic/latest'),
    staleTime:24*60*60*1000,
    gcTime:24*60*60*1000
});


  if (isLoading) return null;
  if (isError) return null;
  if (debateTopicLatest?.data === '') return null;
  return (
    <div className="main_section3">
      <div className="inner">
        <h2>응답하라</h2>
        <div className="question_logo">
          <img src={`${process.env.PUBLIC_URL}/images/common/question_logo.gif`} alt="독서 토론" />
        </div>
        <div className="slide_item">
          <Link to={`/${window.schoolCode}/book/${debateTopicLatest.data?.book.isbn}/debate`} >
            <div className="question_area clear">
              <div className="book_cover_list">
                <div className="book">
                  <div className="book_cover">
                    <div className="book_inner">
                      <img src={debateTopicLatest.data?.book.image} alt={debateTopicLatest.data?.book.title} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="text_area">
                <div className="title_wrap">
                  <div className="book_info">
                    <p className="title">
                      {debateTopicLatest.data?.book.title}
                    </p>
                    <p className="info">
                      <span>{debateTopicLatest.data?.book.author}</span>
                      <span>{debateTopicLatest.data?.book.publisher}</span>
                    </p>
                  </div>
                </div>
                <div className="question p-2 round">
                  <p className="fs-18">{debateTopicLatest.data?.debateContent}</p>
                  <UserProfileInline className="inline p-t-1"
                    id={debateTopicLatest.data?.user.id}
                    image={debateTopicLatest.data?.user.image}
                    name={debateTopicLatest.data?.user.name}
                    type={debateTopicLatest.data?.user.type}
                    school={debateTopicLatest.data?.user.schoolName} />
                </div>
              </div>
            </div>
          </Link>
          <div className="btn_area">
            <Link to={`/${window.schoolCode}/debate`} className="btn _orange _lg _tail">
              <strong className="arrow">토론 목록</strong>
            </Link>
            <Link to={`/${window.schoolCode}/book/${debateTopicLatest.data?.book.isbn}/debate`} className="btn _green _lg">
              <strong className="arrow">
                답글 {debateTopicLatest.data?.debateGcount}
              </strong>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
